// This file was generated using `pay js:run gql-v1 --type=lazy-query --name=V1 --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.
import { useCallback } from 'react';
import { useLazyQuery } from '@sail/data';
import { useMemoizedValue } from '@sail/react';
import { useV1Context } from '../../v1Context';
import mergeContextVariables from '../utils/mergeContextVariables';
export default function useV1LazyQuery(query, options) {
    var _options_variables;
    const v1Context = useV1Context();
    const v1ContextFromHook = useMemoizedValue(mergeContextVariables(v1Context, options === null || options === void 0 ? void 0 : (_options_variables = options.variables) === null || _options_variables === void 0 ? void 0 : _options_variables.v1Context));
    const [callback, result] = useLazyQuery(query, options);
    const callbackWrapped = useCallback((...restArgs)=>{
        var _cbOptions_variables;
        const cbOptions = restArgs[0];
        return callback(Object.assign({}, cbOptions, {
            variables: Object.assign({}, cbOptions === null || cbOptions === void 0 ? void 0 : cbOptions.variables, {
                v1Context: mergeContextVariables(v1ContextFromHook, cbOptions === null || cbOptions === void 0 ? void 0 : (_cbOptions_variables = cbOptions.variables) === null || _cbOptions_variables === void 0 ? void 0 : _cbOptions_variables.v1Context)
            })
        }));
    }, [
        callback,
        v1ContextFromHook
    ]);
    return [
        callbackWrapped,
        result
    ];
}

//# sourceMappingURL=useV1LazyQuery.js.map